import {Injectable, EventEmitter} from '@angular/core';

@Injectable({providedIn:'root'})
export class CmsEventService {
  setSelectedModuleInstance = new EventEmitter();
  setDeviceEmulation = new EventEmitter();
  genericMessage = new EventEmitter();
}